<template>
    <div v-if="showModal" id="worker_detail_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">직원 정보</h3>
            </div>
            <div id="body" class="ui segment">
                <div class="ui form">
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">이름</label>
                            <input type="text" name="name" placeholder="이름을 입력하세요" v-model="name" autocomplete=off :disabled="this.worker">
                            <p class="ui pointing blow orange basic label" v-if="$validator.hasError('name')">{{ $validator.getError('name') }}</p>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">전화번호</label>
                            <input type="text" name="phone" placeholder="010-1234-5678" v-model="phone" autocomplete=off>
                            <p class="ui pointing blow orange basic label" v-if="$validator.hasError('phone')">{{ $validator.getError('phone') }}</p>
                        </div>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <label class="ui left aligned header">직책</label>
                            <select class="ui simple dropdown" v-model="position">
                                <option :value="'배송기사'">배송기사</option>
                                <option :value="'창고관리자'">창고관리자</option>
                                <option :value="'퇴사자'">퇴사자</option>
                            </select>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">설명</label>
                            <input type="text" name="description" placeholder="설명을 입력하세요" v-model="description" autocomplete=off>
                        </div>
                    </div>
                    <div v-for="(region1, i) in Object.keys(center.regions)" :key="i">
                        <div class="fields">
                            <div class="two wide field">
                                <div class="ui fluid selection dropdown">{{ region1 }}</div>
                            </div>
                            <div class="fourteen wide field">
                                <div class="ui clearable multiple selection dropdown">
                                    <input type="hidden" :name="region1" @change="onRegionChange(region1)">
                                    <i class="dropdown icon"></i>
                                    <div class="default text">선택</div>
                                    <div class="menu">
                                        <div class="item" v-for="(region2, i) in region2Options[region1]" :key="i">{{ region2 }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div v-if="!worker && $validator.isAllValidate()" class="ui primary left labeled icon button" @click="save">
                    <i class="checkmark icon"></i>등록
                </div>
                <div v-if="worker && $validator.isAllValidate()" class="ui orange left labeled icon button" @click="save">
                    <i class="checkmark icon"></i>저장
                </div>
                <div class="ui button" @click="close">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, center: 0, worker: 0, name: 0, phone: 0, position: 0, description: 0, regions: 0, onChange: 0, }
    },
    created: function() {
        this.showModal = false;
        this.center = this.worker = this.name = this.phone = this.description = this.regions = this.onChange = 0;
    },
    mounted: function() {
        this.$event.set("addWorker", this.addWorker);
        this.$event.set("editWorker", this.editWorker);
    },
    beforeDestroyed: function() {
        this.$event.clear("addWorker");
        this.$event.clear("editWorker");
    },
    methods: {
        addWorker(center, onChange) {
            if (center.regions)
            {
                this.center = center;
                this.worker = null;
                this.name = "";
                this.phone = "";
                this.position = "배송기사";
                this.description = "";
                this.regions = {};
                this.onChange = onChange;
                this.open();
            }
            else
            {
                alert("센터의 지역을 먼저 설정해주세요");
            }
        },
        editWorker(center, worker, onChange) {
            this.center = center;
            this.worker = worker;
            this.name = worker.name;
            this.phone = worker.phone;
            this.position = worker.position;
            this.description = worker.description;
            this.regions = (worker.regions) ? JSON.parse(JSON.stringify(worker.regions)) : {};
            this.onChange = onChange;
            this.open();
        },

        open() {
            this.showModal = true;
            this.checkValidate();
            this.$nextTick(() => {
                for (var region1 of this.region1Options) {
                    if (this.worker) {
                        $("input[name=" + region1 + "]").attr("value", (this.regions[region1]) ? this.regions[region1].join() : "");
                    } else {
                        $("input[name=" + region1 + "]").attr("value", "");
                    }
                }
                $('.ui.dropdown').dropdown();
            });
        },
        close() {
            this.showModal = false;
        },
        save() {
            if (this.checkValidate()) {
                if (this.worker) {
                    const newWorker = {
                        id: this.phone,
                        name: this.name,
                        phone: this.phone,
                        position: this.position,
                        regions: this.regions,
                        description: this.description,
                    };
                    this.$event.call("openLoading");
                    this.$api.editWorker(this.worker._id, newWorker, (resData) => {
                        this.$event.call("closeLoading");
                        if (resData.error) {
                            alert(resData.error.message);
                        } else {
                            this.onChange();
                            this.close();
                        }
                    });
                } else {
                    const newWorker = {
                        id: this.phone,
                        name: this.name,
                        phone: this.phone,
                        position: this.position,
                        regions: this.regions,
                        description: this.description,
                    };
                    this.$event.call("openLoading");
                    this.$api.addWorker(this.center._id, newWorker, (resData) => {
                        this.$event.call("closeLoading");
                        if (resData.error) {
                            alert(resData.error.message);
                        } else {
                            this.onChange();
                            this.close();
                        }
                    });
                }
            }
        },
        checkValidate() {
            this.$validator.clear();
            this.$validator.checkEmpty("name", this.name);
            this.$validator.checkEmpty("phone", this.phone);
            this.$validator.updateVueIfError(this);
            return this.$validator.isAllValidate();
        },
        onRegionChange(region1)
        {
            const inputValue = $("input[name=" + region1 + "]").attr("value");
            if (inputValue) {
                const region2Array = inputValue.split(',');
                if (region2Array.length > 0) { this.regions[region1] = region2Array; }
            } else {
                delete this.regions[region1];
            }
        },
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        region1Options: function() { return this.$store.getters.region1Options; },
        region2Options: function() { return this.$store.getters.region2Options; },
    },
    watch: {
        name: function(val) { this.name = this.$validator.replaceAlphaKorNum(val); this.checkValidate(); },
        phone: function(val) { this.phone = this.$validator.replacePhone(val); this.checkValidate(); },
    }
}
</script>

<style>

#worker_detail_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#worker_detail_modal .column {
    max-width: 900px;
}

#worker_detail_modal #header {
    padding: 20px 30px;
}

#worker_detail_modal #body {
    padding: 0;
}

#worker_detail_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#worker_detail_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/WorkerModal_Edit.vue